import { render, staticRenderFns } from "./XdocProjectForPDF.vue?vue&type=template&id=7c2101d4&scoped=true"
import script from "./XdocProjectForPDF.vue?vue&type=script&lang=ts"
export * from "./XdocProjectForPDF.vue?vue&type=script&lang=ts"
import style0 from "./XdocProjectForPDF.vue?vue&type=style&index=0&id=7c2101d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2101d4",
  null
  
)

export default component.exports